import { useGetMilkingProcessStats } from 'hook/query/useGetMilkingProcessStats'
import moment from 'moment'
import { useWidgetPreview } from '../context/WidgetPreviewContext'
import { MILKING_PROCESS_STATS_MOCK } from '../mocks/milkingProcessStatsMock'

const startDate = moment().startOf('day').valueOf()
const endDate = moment().endOf('day').valueOf()

export const useWidgetMilkingStats = () => {
	const { isPreview } = useWidgetPreview()
	const real = useGetMilkingProcessStats(startDate, endDate, 'all', undefined, {
		enabled: !isPreview,
	})

	if (isPreview) {
		return {
			data: MILKING_PROCESS_STATS_MOCK,
			isLoading: false,
			isError: false,
			refetch: () => {},
		}
	}

	return real
}
